/**
 * The value of maxExportsPerMonth that represents unlimited exports.
 */
export const UNLIMITED_EXPORTS = -1;

/**
 * The value of maxDownloadsPerMonth that represents unlimited downloads.
 */
export const UNLIMITED_DOWNLOADS = null;
